<template>
<section class="page-music-player page-player fl l-main_wrap">
    <div class="music-disc_thumb player">

        <div class="category-div" v-if="category_list != undefined" style="display:none;">
            <span class="cat_1" v-if="category1!=''">{{ getCategoryTitle('category1') }}</span><span class="cat_2" v-if="category2!=''">{{ getCategoryTitle('category2') }}</span>
            <span class="cat_1" v-if="category1=='' && category2==''">全て</span>
        </div>

        <figure><img :src="'/item/image/'+item_id" alt=""></figure>
        <div class="music-player">
            <div class="data fl_c">
                    <div class="title">{{ content_title }}</div>
                    <p class="release fnt-ftr">{{ item_title }}</p>
            </div>

            <div class="controller">
                <audio id="Audio" data-setup="{}" controls preload="auto" autoplay playsinline></audio>

                <div id="controller-wrapper">
                    <div class="seek-wrap">
                        <div id="seek-slider">
                            <div id="seek-handle"></div>
                        </div>
                        <div id="time-indicator" class="fl">
                            <span id="duration">0:00</span>
                        </div>
                    </div>
                      
                    <div class="audio-btn fl">
                        <div id="prev-button"></div>
                        <div id="play-pause-button"></div>
                        <div id="next-button"></div>
                    </div>
                </div>
            </div>

            <div class="player-option fl" v-if="contents.length">
                <div id="repeat-button" class="rep_addition">
                    <button><img src="/image/tmariko_template/chage/chage/music/repeat-btn.svg" alt="" class="svg"></button>
                </div>
                <div class="fev_addition" v-if="contents[playing_number].favorite_status==0" @click="addFavoriteList(playing_number)">
                    <button><img src="/image/tmariko_template/chage/chage/music/fevorite-btn.svg" alt="" class="svg"></button>
                </div>
                <div class="fev_addition" v-if="contents[playing_number].favorite_status==1" @click="removeFavoriteList(playing_number)">
                    <button><img src="/image/tmariko_template/chage/chage/icn_favorite.svg" alt="" class="svg"></button>
                </div>
            </div>
        </div> 
    </div>
    <div class="music-disc_data">
        <div class="disc_data_head">
            <h3 class="disc-title">{{ item_title }}</h3>
            <!-- <p class="release fnt-ftr">2017-05-03 Release</p> -->
        </div>
              
        <ul class="disc_list">
            <li v-for="(content, index) in contents" :key="index">
                <a tabindex="-1" @click="jump(content.digicon_id)" class="movie_title">{{ content.title }}</a>
                <div class="fev_addition" v-if="content.favorite_status==0" @click="addFavoriteList(index)">
                    <button><img src="/image/tmariko_template/chage/chage/music/fevorite-btn.svg" alt="" class="svg"></button>
                </div>
                <div class="fev_addition" v-if="content.favorite_status==1" @click="removeFavoriteList(index)">
                    <button><img src="/image/tmariko_template/chage/chage/icn_favorite.svg" alt="" class="svg"></button>
                </div>
            </li>
        </ul>
    </div>
</section>
</template>

<script>
    import 'video.js/dist/video-js.css';
    import videojs from 'video.js/dist/video.js';
    export default {
        name: "chage-audio-player",
        props: {
            item_id: {
                type: String,
                default: '0',
            },
            digicon_id: {
                type: String,
            },
            category1: {
                type: String,
                default: '',
            },
            category1_child: {
                type: String,
                default: '',
            },
            category2: {
                type: String,
                default: '',
            },
            category2_child: {
                type: String,
                default: '',
            },
            play_type: {
                type: String,
                default: 'video',
            },
        },
        data: function () {
            return {
                video: undefined,
                content_title: '',
                item_title: '',
                contents: [],
                playing_number: Number,
                getAlbumInfoPath: '',
                getContentInfoPath: '',
                playStartSec: 0,
                recordedFlag: false,
                finFlag: false,
                sample_flag: 0,
                category_list: undefined,
            }
        },
        mounted() {
            this.getAlbumInfoPath = '/purchased/digicon/detail/'+this.item_id;
            this.getContentInfoPath = '/digicon/content/';

            this.video = videojs("Audio", {html5: {
                }},
            );
            this.setVideoConfig();
            axios.default
                .post(this.getAlbumInfoPath, {type: 'content'})
                .then(response => {
                    let contents = response.data;
                    for(let i=0; i<contents.length; i++) {
                        this.$set(this.contents, i, contents[i]);
                    }
                    this.jump(this.digicon_id);
            });
            this.getCategoryList();
        },
        methods: {
            play: function() {
                if(this.finFlag) {
                    this.finFlag = false;
                    this.playing_number = 0;
                    this.setDigicon(this.playing_number);
                    return;
                }
                this.video.play();
                this.resetPlayingSec();
            },
            stop: function() {
                this.video.pause();
            },
            setVideoConfig: function() {
                this.video.on('loadedmetadata', function() {
                    this.recordedFlag = false;
                    this.recordContentsPlayLog();
                    this.play();
                }.bind(this));
                this.video.on('timeupdate', function() {
                    this.recordPlayLog();
                }.bind(this));
                this.video.on('ended', function() {
                    this.forward();
                }.bind(this));
            },
            setDigiconConfig: function(path) {
                this.video.src(path);
            },
            setDigicon: function(playing_number) {
                this.content_title = this.contents[playing_number].title;
                let digicon_id = this.contents[playing_number].digicon_id;
                this.item_title = this.contents[playing_number].item_title;
                axios.default
                    .get(this.getContentInfoPath+digicon_id)
                    .then(response => {
                        let data = response.data;
                        let playing_path = data.fname;
                        this.setDigiconConfig(playing_path);
                    });
            },
            forward: function() {
                this.stop();
                if(this.contents.length-1 <= this.playing_number) {
                    this.finFlag = true;
                    return;
                } else {
                    this.playing_number++;
                }
                this.setDigicon(this.playing_number);
            },
            jump: function(digicon_id) {
                this.stop();
                let index = 0;
                for(let content of this.contents) {
                    if(content.digicon_id == digicon_id) {
                        this.playing_number = index;
                        this.setDigicon(this.playing_number);
                        break;
                    }
                    index++;
                }
            },
            resetPlayingSec: function() {
                this.playStartSec = performance.now();
            },
            recordPlayLog: function() {
                if(!this.checkPlayingSec()) return;
                if(this.recordedFlag) return;
                this.recordedFlag = true;
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .post('/player/log/add', {digicon_id: digicon_id})
                    .then(response => {
                        if(response.data.status=='error') {
                            this.recordedFlag = false;
                        }
                    });
            },
            recordContentsPlayLog: function() {
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .get('/playlog/content/add/'+digicon_id, {sample_flag: this.sample_flag})
                    .then(response => {
                        if(!response.data[0].log_id) {
                            console.log('fail record playlog');
                        }
                    });
            },
            checkPlayingSec: function() {
                if(performance.now() - this.playStartSec < 46000) return false;
                return true;
            },
            addFavoriteList: function(index) {
                let digicon_id = this.contents[index]['digicon_id'];
                axios.default
                    .get('/favorite/content/add/'+digicon_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 1;
                        this.contents[index]['favorite_id'] = res.favorite_id;
                    });
            },
            removeFavoriteList: function(index) {
                let favorite_id = this.contents[index]['favorite_id'];
                axios.default
                    .get('/favorite/content/remove/'+favorite_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 0;
                        this.contents[index]['favorite_id'] = undefined;
                    });
            },
            getCategoryList: function() {
                axios.default
                    .get(`/item/category/list/get?type=${this.play_type}`)
                    .then(response => {
                        this.category_list = response.data;
                    });
            },
            getCategoryTitle: function(category_type) {
                let category_num;
                let child_num;
                switch(category_type) {
                    case 'category1':
                        category_num = this.category1;
                        child_num = this.category1_child;
                        break;
                    case 'category2':
                        category_num = this.category2;
                        child_num = this.category2_child;
                        break;
                }
                if(category_num=='') {
                    return '全て';
                }
                const category_list = this.category_list[category_type];
                const category = category_list.find(element => element.id == category_num);
                if(category) {
                    const child = category['child'].find(element => element.id == child_num);
                    if(child) {
                        return child.title;
                    }
                    return category.title;
                }
                return '';
            },
        },
    }
</script>

<style scoped>
</style>
